import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmAttachmentDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmAttachmentDocument';

import styles from './ErknmPrescribeCancelDocument.module.scss';
import { Attachments } from './Attachments';
import { FieldMark } from '../FieldMark/FieldMark';

interface IErknmPrescribeCancelDocumentProps {
  values: IKnmAttachmentDocument[];
  addAttachment: (data: IKnmAttachmentDocument) => void;
  removeField: () => void;
}

export const ErknmPrescribeCancelDocument = memo(
  ({ values, addAttachment, removeField }: IErknmPrescribeCancelDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <FieldBlock
        label={
          <div className={styles.TitleWrapper}>
            <span className={styles.Title}>
              Загрузка&nbsp;
              <span className="shared-no-wrap-text">
                <FieldMark fieldName="attachment" label="файла" />
                <Button
                  className={'shared-btn-add'}
                  text="Добавить"
                  variant="link"
                  color="primary"
                  type="button"
                  id="fileAddButton"
                  disabled={values.length > 0}
                  onClick={openSignModal}
                />
              </span>
            </span>
            <FormSpy subscription={{ errors: true, touched: true }}>
              {props => {
                if (props.errors?.attachment) {
                  const fieldError = props.errors?.attachment;

                  const errorMessage: string | undefined = fieldError
                    ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
                    : undefined;

                  if (errorMessage) {
                    return <p className="shared-input-error">Поле не может быть пустым</p>;
                  }
                }

                return null;
              }}
            </FormSpy>
          </div>
        }
        placementLabel="left"
        color="black"
        className={styles.FieldBlock}
      >
        <Attachments
          addAttachment={addAttachment}
          removeField={removeField}
          values={values}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          acceptedFiles={'.doc,.docx,.xls,.xlsx,.ods,.pdf'}
        />
      </FieldBlock>
    );
  },
);
